var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",class:{'frame-selected': _vm.selected}},[_c('div',{staticClass:"circle"},[_c('img',{staticClass:"image",attrs:{"src":_vm.icon}})]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }